import React, { Component } from 'react'
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import Header from './Header';
import HeaderLogout from './HeaderLogout';
import Footer from './Footer';
import { ValidateOldCellNumberCtrl } from "../Controllers/Account/ValidateOldCellNumberCtrl";
import { SendOtpNewTelCtrl } from '../Controllers/Account/SendOtpNewTelCtrl';
import { SendPasswordOTPCtrl } from '../Controllers/Account/SendPasswordOTPCtrl';
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader } from '../Utils/Utility';

class Error extends React.Component {

    render() {
        return (
            <Box>
                {this.props.testo ? <Text className='error' style={{ width: '250px', margin: 'auto' }}>{this.props.testo}</Text> : <Text className='errorhide2'></Text>}
            </Box>
        );
    }
}

export default class InsertOTPPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msgError: '',
            next: this.props.values.status,
            dataOldTel:'',
            showTimeoutModal: false,
            loading: false
        }
        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.sendOTP = this.sendOTP.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps !== newProps.values.dataOTP)
            this.setState({
                next: newProps
            })
    }

    saveAndContinue() {
        this.props.otpFunction();
        if (this.state.next === 200) {
            this.props.nextStep();
        }
    }


    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    sendOldNumberOTP = () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        ValidateOldCellNumberCtrl(function (data) {
            self.setState({
                dataOldTel: data === undefined ? {} : data,
                loading: false
            })
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403){
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        state: self.state
                    })  
                } else if (self.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // self.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })

        }, token, ids)
    }

    sendNewTelephone = () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        var telephone = sessionStorage.getItem("newTelephone")
        var self = this;
        self.setState({loading: true});
        SendOtpNewTelCtrl(function (data) {
            self.setState({
                dataNewTel: data,
                loading: false
            })// }, function(){ 
            //     if( self.state.dataNewTel === true){
            //         self.saveAndContinue();
            //     }
            // })
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403){
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        state: self.state
                    })  
                } else if (self.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // self.props.history.push({
                    // pathname: '/login'
                    // })
                } 
            })
        }, telephone, token, ids)
    }

    sendOTP(e) {
        e.preventDefault()
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        SendPasswordOTPCtrl(function (data) {
            self.setState({
                data: data === undefined ? [] : data,
                loading: false
            // }, function(){ 
            //         if( data === true){
            //             this.saveAndContinue();
            //         }
            });
            
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401)
                    {this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                } 
            })

        }, this.state, token, ids);
    }

    render() {

        const defaultOTP = (
            <Box className='contentbox'>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box direction="column" align='center' style={{ margin: '0 auto' }}>
                    <Box direction='row'>
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Inserisci il codice OTP</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <form style={{ margin: '0px !important' }}>
                        <Box style={{ height: '170px', marginBottom: "50px" }}>
                            <Box direction='row' style={{ marginTop: '40px', flexDirection: 'inherit' }}>
                                <Paragraph className='textParagraph' style={{ textAlign: 'center' }} >Inserisci il codice OTP che ti  verrà comunicato tramite sms </Paragraph>
                            </Box>
                            <Box direction='column' margin='medium' style={{ marginTop: '50px' }}>
                                <Text className='label' style={{ margin: 'auto', width: '250px' }}>CODICE OTP</Text>
                                <TextInput id='otp' size='medium' className='inputFormdisp inputNumberNoArrow' style={{ letterSpacing: '11px' }} onChange={this.props.setOtp} maxLength={6} value={this.props.values.otp} />
                                <Error testo={this.props.values.msgOtp} />
                            </Box>
                            
                        </Box>
                        
                            <Box>
                                <Box style={{width: '100%', alignItems: 'center'}}>
                                    <Button className='btnform' style={{width: '250px', marginBottom: '80px'}} label='REINVIA CODICE' onClick={window.location.pathname === '/Setting/ModificaPassword' ? this.sendOTP : window.location.pathname === '/Setting/ModificaTelefono' && this.props.step === 2 ? this.sendOldNumberOTP : this.sendNewTelephone} />
                                </Box>
                                
                                <Box className='informativa' justify='center' direction='row'>
                                    <Button className='btnform' style={{ width: '170px', margin: '0 30px 0 0' }} onClick={this.back}>INDIETRO</Button>
                                    <Button className={this.state.buttonStateOtp ? 'btnform disabled' : 'btnform'} disabled={this.props.values.buttonStateOtp} style={{ width: '170px' }} onClick={this.props.otpFunction}>AVANTI</Button>
                                </Box>
                            </Box>
                            {this.state.loading ? loader : ""}
                    </form>
                </Box>
            </Box >

        )

        const insertOTP = (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                {window.location.pathname !== '/InsertTelephone' ? <Header /> : <HeaderLogout/>}
                <Box style={{ height: '81px' }}></Box>
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    <Box className='contentbox'>
                        <Box direction="row" align='center'>
                            <Box margin='medium' pad='large' alignContent='center' style={{margin: "0 auto"}}>
                                <form>
                                    <Box align='center'>
                                        <Box direction='row'>
                                            <h1 className='fixFont' level='1' style={{ marginBottom: '50px', textAlign: 'center' }}>Inserisci il codice OTP</h1>
                                            <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                                        </Box>

                                        <Box style={{ height: '170px', marginBottom: "30px" }}>
                                            <Box direction='row'>
                                                <Paragraph className='textParagraph'>Inserisci il codice OTP che ti è stato inviato {window.location.pathname === '/Setting/ModificaEmail' ? 'alla mail da te indicata' : 'al numero di telefono da te indicato'} </Paragraph>
                                            </Box>
                                            <Box direction='column' margin='medium' style={{ marginTop: '50px', width: '250px' }} alignSelf='center'>
                                                <Text className='label'>CODICE OTP</Text>
                                                <TextInput id='otp' size='medium' className='inputFormdisp inputNumberNoArrow' style={{ letterSpacing: '11px' }} onChange={this.props.setOtp} maxLength={6} value={this.props.values.otp} />
                                                <Error testo={this.props.values.msgErrorOtp} />
                                            </Box>  
                                        </Box>
                                        
                                            <Box>
                                                <Box style={{width: '100%', alignItems: 'center'}}>
                                                    <Button className='btnform' style={{width: '250px', marginBottom: '80px'}} label='REINVIA CODICE' onClick={this.props.reinviaOTP} />
                                                </Box>
                                                <Box className='informativa' justify='center' direction='row'>
                                                    <Button className='btnform' style={{ width: '170px', margin: '0 30px 0 0' }} onClick={this.back}>INDIETRO</Button>
                                                    <Button className={this.state.buttonStateOtp ? 'btnform disabled' : 'btnform'} disabled={this.props.values.buttonStateOtp} style={{ width: '170px' }} onClick={this.saveAndContinue}>AVANTI</Button>
                                                    {/* <Button className='btnform' disabled={this.props.values.disableOTPButton} style={{ width: '170px' }} onClick={this.saveEmail}>AVANTI</Button> */}
                                                </Box>
                                            </Box>
                                            {this.state.loading ? loader : ""}
                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Footer />
            </Box>

        )

        return (
            <Box>
                {window.location.pathname === '/InsertTelephone' ? insertOTP : defaultOTP}
            </Box>
        )
    }
}
